import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HandlerSnackbarService } from './handler-snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class IncidentsService {
  constructor(
    private readonly http: HttpClient,
    private readonly alertService: HandlerSnackbarService
  ) { }
  pendingIncidents$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  getPendingIncidents() {
    let url = `${environment.baseUrl}/incidents/pending`;
    this.http
      .get<any[]>(url)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return this.alertService.handlerErrorSubscribe(error);
        })
      )
      .subscribe((pendings) => this.pendingIncidents$.next(pendings));
  }

  getHistoryIncidents() {
    let url = `${environment.baseUrl}/incidents/history`;
    return this.http.get(url);
  }

  getIncidents(incidentId: string) {
    let url = `${environment.baseUrl}/incidents/${incidentId}`;
    return this.http.get(url);
  }

  createIncident(body: any) {
    let url = `${environment.baseUrl}/incidents`;
    return this.http.post(url, body, { responseType: 'text' });
  }

  getFormIncident() {
    let url = `${environment.baseUrl}/resources/incident`;
    return this.http.get(url);
  }
}
